export default {
  buttons: {
    save: 'Enregistrer',
  },
  error_messages: {
    product_unavailable: 'Épuisé !',
  },
};
